/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create strong, random passwords right in your browser. Choose the length and character types — your password is generated locally and never sent anywhere.`)
};

const es_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea contraseñas aleatorias y fuertes directamente en tu navegador. Elige la longitud y tipos de caracteres — tu contraseña se genera localmente y nunca se envía a ningún lado.`)
};

const de_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie starke, zufällige Passwörter direkt in Ihrem Browser. Wählen Sie die Länge und Zeichentypen aus — Ihr Passwort wird lokal generiert und niemals irgendwo gesendet.`)
};

const nl_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer sterke, willekeurige wachtwoorden direct in je browser. Kies de lengte en tekentypen — je wachtwoord wordt lokaal gegenereerd en nooit ergens verzonden.`)
};

const fr_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez des mots de passe aléatoires forts directement dans votre navigateur. Choisissez la longueur et les types de caractères — votre mot de passe est généré localement et jamais envoyé nulle part.`)
};

const it_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea password forti e casuali direttamente nel tuo browser. Scegli la lunghezza e i tipi di caratteri — la tua password viene generata localmente e non inviata mai da nessuna parte.`)
};

const pt_br2_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie senhas fortes e aleatórias diretamente em seu navegador. Escolha o comprimento e os tipos de caracteres — sua senha é gerada localmente e nunca é enviada para lugar nenhum.`)
};

const pt_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie senhas fortes e aleatórias diretamente no seu navegador. Escolha o comprimento e os tipos de caracteres — a sua senha é gerada localmente e nunca enviada para lado nenhum.`)
};

const ja_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザで直接強力でランダムなパスワードを作成できます。長さと文字タイプを選択すれば、パスワードはローカルで生成され、どこにも送信されません。`)
};

const zh_pw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在浏览器中创建强随机密码。选择长度和字符类型——密码在本地生成，绝不会发送到任何地方。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_intro", locale)
	if (locale === "en") return en_pw_intro(inputs)
	if (locale === "es") return es_pw_intro(inputs)
	if (locale === "de") return de_pw_intro(inputs)
	if (locale === "nl") return nl_pw_intro(inputs)
	if (locale === "fr") return fr_pw_intro(inputs)
	if (locale === "it") return it_pw_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pw_intro(inputs)
	if (locale === "pt") return pt_pw_intro(inputs)
	if (locale === "ja") return ja_pw_intro(inputs)
	return zh_pw_intro(inputs)
};